/*
 * GUSTA CUSTOMIZATION: PRODUCT REVIEW ANCHOR
 * Scope: product pages only.
 * Purpose: make Warehouse's existing #product-reviews links land at the
 * top of the Judge.me review area with the heading visible below the
 * sticky Warehouse header.
 */
(function () {
  'use strict';

  var TARGET_ID = 'product-reviews';
  var TARGET_HASH = '#' + TARGET_ID;
  var WIDGET_SELECTOR = '#judgeme_product_reviews, .jdgm-review-widget, .jdgm-rev-widg';
  var REVIEW_LINK_SELECTOR = 'a[href$="#product-reviews"]';
  var PAGINATION_SELECTOR = '.jdgm-paginate__page';
  var PAGINATION_REPAIR_ATTRIBUTE = 'data-gusta-pagination-repaired';
  var pendingScroll = window.location.hash === TARGET_HASH;
  var pendingBehavior = 'auto';
  var refreshQueued = false;
  var settleTimer = null;

  function target() {
    return document.getElementById(TARGET_ID);
  }

  function reviewWidget() {
    return document.querySelector(WIDGET_SELECTOR);
  }

  function ensureAnchor() {
    var existing = target();
    if (existing) return existing;

    var widget = reviewWidget();
    if (!widget || !widget.parentNode) return null;

    var anchor = document.createElement('span');
    anchor.id = TARGET_ID;
    anchor.setAttribute('data-gusta-product-reviews-anchor', '');
    anchor.setAttribute('aria-hidden', 'true');
    anchor.style.display = 'block';
    anchor.style.height = '0';
    anchor.style.scrollMarginTop = 'calc(var(--header-height, 0px) + 24px)';

    widget.parentNode.insertBefore(anchor, widget);
    return anchor;
  }

  function repairPaginationLinks() {
    var widget = reviewWidget();
    if (!widget) return;

    widget.querySelectorAll(PAGINATION_SELECTOR).forEach(function (element) {
      if (element.hasAttribute(PAGINATION_REPAIR_ATTRIBUTE)) return;

      // Judge.me's documented workaround for theme JavaScript conflicts is to
      // recreate each pagination control. The marker prevents our observer from
      // recreating the same control again after that DOM replacement.
      element.setAttribute(PAGINATION_REPAIR_ATTRIBUTE, '');
      element.outerHTML = element.outerHTML;
    });
  }

  function scrollToReviews(behavior) {
    var anchor = ensureAnchor();
    if (!anchor) return false;

    anchor.scrollIntoView({
      block: 'start',
      behavior: behavior || 'auto'
    });

    return true;
  }

  function confirmFinalPosition() {
    window.clearTimeout(settleTimer);

    settleTimer = window.setTimeout(function () {
      if (window.location.hash === TARGET_HASH) {
        scrollToReviews('auto');
      }
    }, 350);
  }

  function finishPendingScroll() {
    if (!pendingScroll || !scrollToReviews(pendingBehavior)) return;

    pendingScroll = false;
    pendingBehavior = 'auto';
    confirmFinalPosition();
  }

  function refresh() {
    refreshQueued = false;
    ensureAnchor();
    repairPaginationLinks();
    finishPendingScroll();
  }

  function queueRefresh() {
    if (refreshQueued) return;

    refreshQueued = true;
    window.requestAnimationFrame(refresh);
  }

  function isCurrentPageReviewLink(link) {
    if (!link) return false;

    try {
      var url = new URL(link.href, window.location.href);
      return url.hash === TARGET_HASH &&
        url.origin === window.location.origin &&
        url.pathname === window.location.pathname;
    } catch (error) {
      return false;
    }
  }

  function preferredBehavior() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches
      ? 'auto'
      : 'smooth';
  }

  document.addEventListener('click', function (event) {
    if (
      event.defaultPrevented ||
      event.button !== 0 ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey
    ) {
      return;
    }

    var clicked = event.target;
    var link = clicked instanceof Element ? clicked.closest(REVIEW_LINK_SELECTOR) : null;

    if (!isCurrentPageReviewLink(link)) return;

    event.preventDefault();
    pendingBehavior = preferredBehavior();

    if (window.location.hash !== TARGET_HASH) {
      window.history.pushState(null, '', TARGET_HASH);
    }

    if (scrollToReviews(pendingBehavior)) {
      pendingScroll = false;
      pendingBehavior = 'auto';
      confirmFinalPosition();
      return;
    }

    // If Judge.me has not rendered yet, retain the requested destination and
    // complete the scroll as soon as the review widget becomes available.
    pendingScroll = true;
    queueRefresh();
  }, true);

  window.addEventListener('hashchange', function () {
    if (window.location.hash !== TARGET_HASH) return;

    pendingScroll = true;
    pendingBehavior = 'auto';
    queueRefresh();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', queueRefresh, { once: true });
  } else {
    queueRefresh();
  }

  if ('MutationObserver' in window) {
    var observerRoot = document.getElementById('main') || document.body;

    if (observerRoot) {
      new MutationObserver(queueRefresh).observe(observerRoot, {
        childList: true,
        subtree: true
      });
    }
  }

  document.addEventListener('shopify:section:load', queueRefresh);
})();
